import React from "react";
import "./ContentPage.css";

const privacyPolicies = [
  {
    title: "Introduction",
    content:
      "Core Bankers, a brand of VedhaNirvana Private Limited, is committed to protecting your privacy. This policy outlines how we collect, use, and safeguard your personal information when you engage with our loan facilitation services. We ensure compliance with industry standards and regulatory guidelines to maintain transparency and trust with our users.",
  },
  {
    title: "Information We Collect",
    content:
      "We collect personal details such as name, contact information, financial data, and loan preferences. This information is gathered through loan applications, inquiries, and interactions with our website. Additionally, we may collect data related to your browsing behavior, device information, and communication preferences to enhance user experience and service efficiency.",
  },
  {
    title: "How We Use Your Information",
    content:
      "Your data is used to process loan applications, verify eligibility, communicate updates, and improve our services. We do not sell or share your information with unauthorized third parties. We may use anonymized data for analytics, fraud prevention, and service enhancements to ensure a seamless loan facilitation process.",
  },
  {
    title: "Data Security Measures",
    content:
      "We implement strict security protocols to protect your data from unauthorized access, breaches, and misuse. Encryption, secure servers, and compliance with industry standards ensure data protection. Our security framework includes multi-layer authentication, regular audits, and restricted access to sensitive information.",
  },
  {
    title: "Third-Party Sharing",
    content:
      "We share necessary information with banks and NBFCs for loan processing. All third-party interactions comply with legal and regulatory requirements to safeguard your privacy. We ensure that our partners adhere to strict confidentiality agreements and data protection policies to prevent misuse of personal information.",
  },
  {
    title: "Cookies & Tracking Technologies",
    content:
      "Our website may use cookies to enhance user experience, analyze traffic, and personalize content. Users can manage cookie preferences through browser settings. Cookies help us understand user behavior, optimize website performance, and provide relevant loan recommendations based on browsing patterns.",
  },
  {
    title: "User Rights & Choices",
    content:
      "You have the right to access, update, or request deletion of your personal data. Contact us for any privacy-related concerns or requests. Users can also opt out of marketing communications, modify consent preferences, and request detailed reports on how their data is being used.",
  },
  {
    title: "Data Retention Policy",
    content:
      "We retain personal data only as long as necessary for loan processing and legal compliance. Once the purpose is fulfilled, data is securely deleted. Retention periods vary based on regulatory requirements, fraud prevention measures, and contractual obligations with financial institutions.",
  },
  {
    title: "Legal Compliance",
    content:
      "Core Bankers adheres to all applicable data protection laws, including RBI guidelines for digital lending and financial data security. We ensure compliance with GDPR, IT Act 2000, and other relevant regulations to protect user privacy and prevent unauthorized data usage.",
  },
  {
    title: "Policy Updates",
    content:
      "We may update this Privacy Policy periodically. Users are encouraged to review changes to stay informed about data handling practices. Any significant modifications will be communicated via email or website notifications to ensure transparency and user awareness.",
  },
];

const PrivacyPolicy = () => {
  return (
    <main className="content-page">
      <section className="content-hero">
        <div className="content-hero-inner">
          <span className="cb-section-label">Legal</span>
          <h1>Privacy Policy</h1>
          <p>Your privacy matters to us. Learn how we protect and manage your personal data.</p>
        </div>
      </section>

      <div className="content-body">
        {privacyPolicies.map((policy) => (
          <section className="content-section" key={policy.title}>
            <h2>{policy.title}</h2>
            <p>{policy.content}</p>
          </section>
        ))}
        <p className="content-disclaimer">
          Disclaimer: Core Bankers operates as a Direct Selling Agent (DSA) under VedhaNirvana Private Limited,
          facilitating loan services from various banks and NBFCs. Loan approvals and terms are subject to lender policies.
        </p>
      </div>
    </main>
  );
};

export default PrivacyPolicy;
